import { IgButton } from "@intelligems/ig-theme";
import { organizationScriptStatusKey } from "@src/api/queryKeys";
import {
  clearFailedScriptStatusRequests,
  useGetScriptStatus,
} from "@src/api/shops/get-script-status";
import { useQueryClient } from "@tanstack/react-query";

interface RecheckButtonProps {
  orgId: string | undefined;
  additionalAlert?: boolean;
}

const RECHECK_BUTTON_SX = {
  default: {
    color: "white",
    "&:hover": { color: "black" },
  },
  additional: {
    color: "black",
    "&:hover": { color: "black" },
  },
} as const;

export const RecheckButton = ({
  orgId,
  additionalAlert,
}: RecheckButtonProps) => {
  const queryClient = useQueryClient();
  const scriptStatusQuery = useGetScriptStatus(orgId);

  return (
    <IgButton
      key="recheck"
      size="extraSmall"
      loading={scriptStatusQuery.isFetching}
      variant="outlined"
      sx={
        additionalAlert
          ? RECHECK_BUTTON_SX.additional
          : RECHECK_BUTTON_SX.default
      }
      onClick={() => {
        if (orgId) {
          clearFailedScriptStatusRequests(orgId);
          void queryClient.invalidateQueries({
            queryKey: organizationScriptStatusKey.org(orgId),
            exact: false,
          });
        }
      }}
    >
      Recheck
    </IgButton>
  );
};
